// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1fhp0","content":"LoadingAlert_content__sONKk"};